import { useEffect, useState } from "react";
import MenuApp from '../../../components/Menu';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import informationService from '../../../services/system';
import AuthService from "../../../services/security/auth.service";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import TableChartIcon from '@mui/icons-material/TableChart';
import TrendingUp from '@mui/icons-material/TrendingUp';
import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import Button from '@mui/material/Button';
import { ThemeProvider } from '@mui/material/styles';
import constantsDesign from '../../../utils/constants';
import DateComponent from '../../../components/Date';
import TokenService from "../../../services/security/token.service";
import { BlobProvider } from "@react-pdf/renderer";
import RefreshIcon from '@mui/icons-material/Refresh';
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import PerformancePdfExport from "../../../components/PerformancePdfExport";
import CircularProgress from '@mui/material/CircularProgress';

const Performance = () => {
    const user = TokenService.getUser();
    const [performanceReponse, setPerformanceResponse] = useState([]);
    const [loadSubtotalesCards, setLoadSubtotalesCards] = useState(false);
    const [homeTrade, setHomeTrade] = useState('ars');
    const [filterDate, setFilterDate] = useState(null);
    const [filterDateHasta, setFilterDateHasta] = useState(null);
    const [filterComitente, setFilterComitente] = useState(null);
    const [inputValue, setInputValue] = useState('');
    const [optionsComitentes, setOptionsComitentes] = useState([]);
    const [optionsComitentesOriginales, setOptionsComitentesOriginales] = useState([]);
    const [filterManager, setFilterManager] = useState(null);
    const [inputValueManager, setInputValueManager] = useState('');
    const [optionsManager, setOptionsManager] = useState([]);
    const [viewComitente, setViewComitente] = useState(false);
    const [viewManager, setViewManager] = useState(false);

    useEffect(() => {

        const init = async () => {

            document.title = `Performance - wBroker`;
            setLoadSubtotalesCards(false);
            searchSourceField();
            let dateNow = formatDate(new Date());

            const filterDate = new Date();
            filterDate.setMonth(0);
            filterDate.setDate(1);
            let dateNow1 = formatDate(filterDate);
            setFilterDate(dateNow1);
            setFilterDateHasta(dateNow);

            loadInfo(dateNow1, dateNow, filterComitente, filterManager);

            if (user.data.managerId && user.data.tradeAccountId) {
                setViewComitente(true);
                setViewManager(false);
            } else {
                if (user.data.managerId && !user.data.tradeAccountId) {
                    setViewComitente(true);
                    setViewManager(true);
                } else {
                    if (!user.data.managerId && !user.data.tradeAccountId) {
                        setViewComitente(true);
                        setViewManager(true);
                    }
                }
            }
        }
        init();
        // eslint-disable-next-line
    }, []);

    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }


    const filterByTradeAccountIdManagerId = (tradeAccountId, managerId) => {
        const user = AuthService.getCurrentUser();
        let whereFieldParam = [];

        if (user.data.companyId) {
            whereFieldParam.push({
                idField: 'companyId',
                operator: '=',
                value: user.data.companyId
            })
        } else {
            whereFieldParam.push({
                idField: 'companyId',
                operator: '=',
                value: null
            })
        }

        if (user.data.tradeAccountId) {
            whereFieldParam.push({
                idField: 'tradeAccountId',
                operator: '=',
                value: tradeAccountId !== null ? tradeAccountId.id : user.data.tradeAccountId
            })
        } else {
            whereFieldParam.push({
                idField: 'tradeAccountId',
                operator: '=',
                value: tradeAccountId !== null ? tradeAccountId.id : null
            })
        }

        if (user.data.managerId) {
            whereFieldParam.push({
                idField: 'managerId',
                operator: '=',
                value: managerId !== null ? managerId.id : user.data.managerId
            })
        } else {
            whereFieldParam.push({
                idField: 'managerId',
                operator: '=',
                value: managerId !== null ? managerId.id : null
            })
        }


        return whereFieldParam;
    }

    const filterByTradeAccountIdManagerIdFindSourceField = () => {
        const user = AuthService.getCurrentUser();
        let whereFieldParam = [];
        if (user.data.companyId) {
            let existe = false;
            whereFieldParam.forEach((item) => {
                if (item.idField === 'companyId') {
                    existe = true;
                    item.value = user.data.companyId
                }
            })
            if (existe === false) {
                whereFieldParam.push({
                    idField: 'companyId',
                    operator: '=',
                    value: user.data.companyId
                })
            }
        }

        if (user.data.tradeAccountId) {
            let existe = false;
            whereFieldParam.forEach((item) => {
                if (item.idField === 'tradeAccountId') {
                    existe = true;
                    item.value = user.data.tradeAccountId
                }
            })
            if (existe === false) {
                whereFieldParam.push({
                    idField: 'tradeAccountId',
                    operator: '=',
                    value: user.data.tradeAccountId
                })
            }
        } else {
            if (user.data.isManager === '1') {
                let existe = false;
                whereFieldParam.forEach((item) => {
                    if (item.idField === 'managerId') {
                        existe = true;
                        item.value = user.data.managerId
                    }
                })
                if (existe === false) {
                    whereFieldParam.push({
                        idField: 'managerId',
                        operator: '=',
                        value: user.data.managerId
                    })
                }
            }
        }
        return whereFieldParam;
    }

    const searchSourceField = () => {
        let whereFilters = filterByTradeAccountIdManagerIdFindSourceField();

        const arrayTables = [{
            table: `${user.data.instance}.tradeAccount`,
            doc: [],
            selectFilters: ['managerId'],
            whereFilters: whereFilters
        }, {
            table: `${user.data.instance}.manager`,
            doc: [],
            selectFilters: [],
            whereFilters: whereFilters
        }]

        informationService.findSourceField(arrayTables).then((response) => {

            let opcComitentes = [];
            let opcManager = [];
            for (let t = 0; t < response.data.length; t++) {
                if (response.data[t].source === 'tradeAccount' && response.data[t].isInactive === '0') {
                    opcComitentes.push({
                        id: response.data[t].id,
                        label: (response.data[t].nameAlt !== undefined && response.data[t].nameAlt !== '') ? `${response.data[t].name} ${response.data[t].nameAlt}` : `${response.data[t].name}`,
                        isInactive: response.data[t].isInactive,
                        managerId: response.data[t].managerId
                    })
                }
                if (response.data[t].source === 'manager' && response.data[t].isInactive === '0') {
                    opcManager.push({
                        id: response.data[t].id,
                        label: (response.data[t].nameAlt !== undefined && response.data[t].nameAlt !== '') ? `${response.data[t].name} ${response.data[t].nameAlt}` : `${response.data[t].name}`,
                        isInactive: response.data[t].isInactive,
                    })
                }
            }

            let managerId = 0;
            if (user.data.isManager === '1') {
                setFilterManager({
                    id: user.data.managerId,
                    label: user.data.manager,
                    isInactive: 0,
                });
                managerId = user.data.managerId;
            }
            if (user.data.tradeAccountId && user.data.managerId) {
                setFilterComitente({
                    id: user.data.tradeAccountId,
                    label: user.data.tradeAccount,
                    isInactive: 0,
                })
            }

            if (managerId > 0) {
                let arrayOptCom = [];
                for (let g = 0; g < opcComitentes.length; g++) {
                    if (Number(opcComitentes[g].managerId) === Number(managerId)) {
                        arrayOptCom.push(opcComitentes[g]);
                    }
                }
                setOptionsComitentes(arrayOptCom);
            } else {
                setOptionsComitentes(opcComitentes);
            }
            setOptionsComitentesOriginales(opcComitentes);
            setOptionsManager(opcManager);

            setLoadSubtotalesCards(true);

        })
    }

    const loadInfo = (fechaDesde, fechaHasta, tradeAccountId, managerId) => {
        const user = AuthService.getCurrentUser();

        let date = fechaDesde.split('-');
        let fechaDesdeFlag = new Date(date[0], Number(date[1]) - 1, date[2]);
        let fechaDesdeParam = formatDate(fechaDesdeFlag);

        date = fechaHasta.split('-');
        let fechaHastaFlag = new Date(date[0], Number(date[1]) - 1, date[2]);
        let fechaHastaParam = formatDate(fechaHastaFlag);

        let where = filterByTradeAccountIdManagerId(tradeAccountId, managerId);

        informationService.storeProcedurePerformance('performance', user.data.instance, fechaDesdeParam, fechaHastaParam, where).then((response) => {

            setPerformanceResponse(response.data.length > 0 ? response.data : []);
            setLoadSubtotalesCards(true);
        }).catch((error) => {
            setLoadSubtotalesCards(true);

            console.log(error);
        });
    }

    const handleFieldChange = (e) => {
        let value = e.target.value;
        setFilterDate(value);
        setLoadSubtotalesCards(false);

        loadInfo(value, filterDateHasta, filterComitente, filterManager);
    }

    const handleFieldChangeHasta = (e) => {
        let value = e.target.value;
        setFilterDateHasta(value);
        setLoadSubtotalesCards(false);

        loadInfo(filterDate, value, filterComitente, filterManager);
    }

    const handleInputChange = (event, newInputValue) => {
        setInputValue(newInputValue);

        const filtered = optionsComitentes.filter((option) =>
            option.label.toLowerCase().includes(newInputValue.toLowerCase())
        );
        if (filtered.length === 1) {
            setFilterComitente(filtered[0]);
            setLoadSubtotalesCards(false);
            let manag = null;
            for (let g = 0; g < optionsManager.length; g++) {
                if (Number(optionsManager[g].id) === Number(filtered[0].managerId))
                    manag = optionsManager[g];
            }

            setFilterManager(manag);
            loadInfo(filterDate, filterDateHasta, filtered[0], filterManager)

        }
    };

    const handleChange = (event, newValue) => {
        setFilterComitente(newValue);
        setLoadSubtotalesCards(false);
        let manag = null;
        if (newValue) {
            for (let g = 0; g < optionsManager.length; g++) {
                if (Number(optionsManager[g].id) === Number(newValue.managerId))
                    manag = optionsManager[g];
            }
        }

        setFilterManager(manag);
        loadInfo(filterDate, filterDateHasta, newValue, filterManager)

    };

    const handleInputChangeManager = (event, newInputValue) => {
        setInputValueManager(newInputValue);

        const filtered = optionsManager.filter((option) =>
            option.label.toLowerCase().includes(newInputValue.toLowerCase())
        );
        if (filtered.length === 1) {
            setFilterManager(filtered[0]);
            setLoadSubtotalesCards(false);
            let arrayOptCom = [];
            for (let g = 0; g < optionsComitentesOriginales.length; g++) {
                if (optionsComitentesOriginales[g].managerId === filtered[0].id) {
                    arrayOptCom.push(optionsComitentesOriginales[g]);
                }
            }
            setOptionsComitentes(arrayOptCom);
            loadInfo(filterDate, filterDateHasta, filterComitente, filtered[0])

        }
    };

    const handleChangeManager = (event, newValue) => {
        setFilterManager(newValue);
        setLoadSubtotalesCards(false);
        let arrayOptCom = [];
        for (let g = 0; g < optionsComitentesOriginales.length; g++) {
            if (optionsComitentesOriginales[g].managerId === newValue.id) {
                arrayOptCom.push(optionsComitentesOriginales[g]);
            }
        }
        setOptionsComitentes(arrayOptCom);
        loadInfo(filterDate, filterDateHasta, filterComitente, newValue)

    };


    const handleChangeHomeTrade = (homeTrade) => {
        setHomeTrade(homeTrade);
    }


    const setViewPerformance = (item, homeTrade, mode = "ui") => {

        const isPdf = mode === "pdf";
        const fontSize = isPdf ? "8px" : "inherit";
        const cellPadding = isPdf ? "4px" : undefined;

        let endFx = homeTrade === 'ars' ? (item.endFx !== null && item.endFx !== undefined) ? Number(item.endFx).toFixed(0) : '' : (item.endUsd !== null && item.endUsd !== undefined) ? Number(item.endUsd).toFixed(0) : '';
        let endFxFormat;

        if (item.period === 'Inicio' && Number(endFx) === 0) {
            endFxFormat = "";
        } else {
            endFxFormat = `${Number(endFx).toLocaleString('es-AR')}`;
        }

        let netFx = homeTrade === 'ars' ? (item.netFx !== null && item.netFx !== undefined) ? Number(item.netFx).toFixed(0) : '' : (item.netUsd !== null && item.netUsd !== undefined) ? Number(item.netUsd).toFixed(0) : '';
        let netFxFormat;
        console.log('item.period-> ' + item.period)
        console.log('Number(netFx)-> ' + Number(netFx))

        if (item.period === 'Inicio' && Number(netFx) === 0) {
            netFxFormat = "";
        } else {
            netFxFormat = `${Number(netFx).toLocaleString('es-AR')}`;
        }


        let changeFx = homeTrade === 'ars' ? (item.changeFx !== null && item.changeFx !== undefined) ? Number(item.changeFx).toFixed(0) : '' : (item.changeUsd !== null && item.changeUsd !== undefined) ? Number(item.changeUsd).toFixed(0) : '';
        let changeFxFormat;
        if (item.period === 'Inicio' && Number(changeFx) === 0) {
            changeFxFormat = "";
        } else {
            changeFxFormat = `${Number(changeFx).toLocaleString('es-AR')}`;
        }

        let pctFx = homeTrade === 'ars' ? (item.pctFx !== null && item.pctFx !== undefined) ? Number(item.pctFx) * 100 : '' : (item.pctUsd !== null && item.pctUsd !== undefined) ? Number(item.pctUsd) * 100 : '';
        let pctFxFormat;
        if (item.period === 'Inicio' && Number(pctFx) === 0) {
            pctFxFormat = "";
        } else {
            pctFxFormat = Number(pctFx).toFixed(2).toString().replace(/\./g, ',');
            let valueSplit = pctFxFormat.split(',');
            if (valueSplit.length > 1) {
                pctFxFormat = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)} %`;
            } else {
                pctFxFormat = `${Number(valueSplit[0]).toLocaleString('es-AR')} %`;
            }

        }


        let inicio = (item.periodStart !== null && item.periodStart !== undefined) ? `${item.periodStart.split('-')[2]}/${item.periodStart.split('-')[1]}/${item.periodStart.split('-')[0].substring(2, 4)}` : '';
        let fin = (item.periodEnd !== null && item.periodEnd !== undefined) ? `${item.periodEnd.split('-')[2]}/${item.periodEnd.split('-')[1]}/${item.periodEnd.split('-')[0].substring(2, 4)}` : '';

        let responseView = [];
        responseView.push(
            <TableRow
                sx={{
                    '& td': {
                        borderTop: item.period === 'Total' ? '2px solid #000' : undefined
                    }
                }}
            >
                <TableCell style={{
                    fontWeight: item.period === 'Total' ? 'bold' : 'normal',
                    fontSize,
                    padding: cellPadding,
                    whiteSpace: 'nowrap',
                    width: '1%'
                }}>{item.period}</TableCell>
                <TableCell style={{
                    fontWeight: item.period === 'Total' ? 'bold' : 'normal',
                    fontSize,
                    padding: cellPadding
                }} align='right'>{inicio}</TableCell>
                <TableCell style={{
                    fontWeight: item.period === 'Total' ? 'bold' : 'normal',
                    fontSize,
                    padding: cellPadding
                }} align='right'>{fin}</TableCell>
                <TableCell style={{
                    fontWeight: item.period === 'Total' ? 'bold' : 'normal',
                    fontVariantNumeric: 'tabular-nums',
                    letterSpacing: "0.01rem",
                    color: Number(endFx) < 0 ? "red" : "black",
                    fontSize,
                    padding: cellPadding,
                    lineHeight: isPdf ? 1.2 : "normal"
                }}
                    align='right'
                >{endFxFormat}</TableCell>
                <TableCell style={{
                    fontWeight: item.period === 'Total' ? 'bold' : 'normal',
                    fontVariantNumeric: 'tabular-nums',
                    letterSpacing: "0.01rem",
                    color: Number(netFx) < 0 ? "red" : "black",
                    fontSize,
                    padding: cellPadding,
                    lineHeight: isPdf ? 1.2 : "normal"
                }}
                    align='right'
                >{netFxFormat}</TableCell>
                <TableCell style={{
                    fontWeight: item.period === 'Total' ? 'bold' : 'normal',
                    fontVariantNumeric: 'tabular-nums',
                    letterSpacing: "0.01rem",
                    color: Number(changeFx) < 0 ? "red" : "black",
                    fontSize,
                    padding: cellPadding,
                    lineHeight: isPdf ? 1.2 : "normal"
                }}
                    align='right'
                >{changeFxFormat}</TableCell>
                <TableCell style={{
                    fontWeight: item.period === 'Total' ? 'bold' : 'normal',
                    fontVariantNumeric: 'tabular-nums',
                    letterSpacing: "0.01rem",
                    color: Number(pctFx) < 0 ? "red" : "black",
                    fontSize,
                    padding: cellPadding,
                    lineHeight: isPdf ? 1.2 : "normal"
                }}
                    align='right'
                >{pctFxFormat}</TableCell>
            </TableRow>
        )
        return responseView;
    }

    const exportToExcel = () => {

        const headers = [
            "Periodo",
            "Inicio",
            "Fin",
            `Posición (${homeTrade.toUpperCase()})`,
            `Contribución (${homeTrade.toUpperCase()})`,
            `Cambio (${homeTrade.toUpperCase()})`,
            "Portfolio (%)"
        ];

        const aoa = [];
        aoa.push(headers);

        performanceReponse.forEach((item) => {

            const endFx = homeTrade === "ars"
                ? (item.endFx != null ? Number(item.endFx).toFixed(0) : null)
                : (item.endUsd != null ? Number(item.endUsd).toFixed(0) : null);

            const netFx = homeTrade === "ars"
                ? (item.netFx != null ? Number(item.netFx).toFixed(0) : null)
                : (item.netUsd != null ? Number(item.netUsd).toFixed(0) : null);

            const changeFx = homeTrade === "ars"
                ? (item.changeFx != null ? Number(item.changeFx).toFixed(0) : null)
                : (item.changeUsd != null ? Number(item.changeUsd).toFixed(0) : null);

            // NO multiplico por 100.
            // Si el valor es 0.1234, Excel lo mostrará como 12,34 %.
            const pctFx = homeTrade === "ars"
                ? (item.pctFx != null ? Number(item.pctFx) : null)
                : (item.pctUsd != null ? Number(item.pctUsd) : null);

            const inicio = item.periodStart
                ? `${item.periodStart.split("-")[2]}/${item.periodStart.split("-")[1]}/${item.periodStart.split("-")[0].substring(2, 4)}`
                : "";

            const fin = item.periodEnd
                ? `${item.periodEnd.split("-")[2]}/${item.periodEnd.split("-")[1]}/${item.periodEnd.split("-")[0].substring(2, 4)}`
                : "";

            aoa.push([
                item.period,
                inicio,
                fin,
                endFx !== null ? Number(endFx) : null,
                netFx !== null ? Number(netFx) : null,
                changeFx !== null ? Number(changeFx) : null,
                pctFx
            ]);
        });

        const worksheet = XLSX.utils.aoa_to_sheet(aoa);

        // Formato de números
        Object.keys(worksheet).forEach(cell => {

            if (cell.startsWith("!")) return;

            if (typeof worksheet[cell].v === "number") {

                // Columna G (Portfolio %)
                if (cell.match(/^G/)) {
                    worksheet[cell].z = '0.00%';
                } else {
                    worksheet[cell].z = '#,##0';
                }
            }
        });

        // Ancho de columnas
        worksheet["!cols"] = [
            { wch: 12 },
            { wch: 12 },
            { wch: 12 },
            { wch: 18 },
            { wch: 18 },
            { wch: 18 },
            { wch: 15 }
        ];

        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(workbook, worksheet, "Performance");

        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array"
        });

        const blob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        const moneda = homeTrade.toUpperCase();

        const desde = filterDate
            ? filterDate.replaceAll("-", "")
            : "";

        const hasta = filterDateHasta
            ? filterDateHasta.replaceAll("-", "")
            : "";

        const nombre = [
            "Performance",
            moneda,
            desde,
            hasta
        ].join("_");

        saveAs(blob, `${nombre}.xlsx`);
    };

    return (

        <>
            <ThemeProvider theme={constantsDesign.CUSTOM_MUI_GENERAL_THEME}>
                <div style={{ overflowX: 'hidden' }}>
                    <MenuApp />
                    <Box border={1} marginTop="4rem" borderColor="rgb(0 0 0 / 13%)" borderRadius="4px" p={2} padding={1}>
                        <Box display="flex" alignItems="center" gap={1}>


                            <ThemeProvider theme={constantsDesign.CUSTOM_MUI_BUTTON_THEME}>

                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: { xs: "column", md: "row" }, // columna en mobile, fila en grande
                                        gap: 1
                                    }}
                                >
                                    <Box
                                        sx={{
                                            display: "flex",
                                            flexDirection: "row",
                                            alignItems: "center",
                                            gap: 1
                                        }}
                                    >
                                        <TrendingUp fontSize="large" />

                                        <Button
                                            color="primary"
                                            variant={homeTrade === 'ars' ? 'contained' : 'outlined'}
                                            sx={{ height: 32, minWidth: 50 }}
                                            onClick={() => handleChangeHomeTrade('ars')}
                                        >
                                            ARS
                                        </Button>

                                        <Button
                                            color="primary"
                                            variant={homeTrade !== 'ars' ? 'contained' : 'outlined'}
                                            sx={{ height: 32, minWidth: 50 }}
                                            onClick={() => handleChangeHomeTrade('usd')}
                                        >
                                            USD
                                        </Button>

                                        <DateComponent
                                            disabled={false}
                                            id="filterDate"
                                            name="Desde"
                                            value={filterDate}
                                            onChange={(newDate) => handleFieldChange({ target: { value: newDate } })}
                                            help={null}
                                            mode="c"
                                            design={null}
                                            view={null}
                                        />

                                        <DateComponent
                                            disabled={false}
                                            id="filterDate"
                                            name="Hasta"
                                            value={filterDateHasta}
                                            onChange={(newDate) => handleFieldChangeHasta({ target: { value: newDate } })}
                                            help={null}
                                            mode="c"
                                            design={null}
                                            view={null}
                                        />

                                        <Button
                                            variant="text"
                                            size="small"
                                            //onClick={updatePrice}
                                            style={{ fontSize: "inherit", lineHeight: "inherit", color: 'black', textDecoration: "underline" }}
                                        >
                                            <RefreshIcon />
                                        </Button>
                                    </Box>

                                    <Box
                                        sx={{
                                            display: "flex",
                                            flexDirection: { xs: "column", sm: "row" }, // apila en mobile, fila en grande
                                            gap: 1,
                                            flex: 1
                                        }}
                                    >

                                        <Box sx={{ minWidth: 250, maxWidth: 300, flex: 1 }}>
                                            <Autocomplete
                                                options={optionsComitentes}
                                                getOptionLabel={(option) => option.label}
                                                value={filterComitente}
                                                onChange={handleChange}
                                                inputValue={inputValue}
                                                onInputChange={handleInputChange}
                                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                                disabled={(user.data.managerId && user.data.tradeAccountId) ? true : false}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Cuenta Comitente"
                                                        variant="outlined"
                                                        sx={{
                                                            '& .MuiInputBase-root': {
                                                                height: 32,
                                                                minHeight: 32,
                                                                paddingRight: '8px',
                                                                fontSize: "inherit",
                                                                fontWeight: '600',
                                                                lineHeight: "inherit"
                                                            },
                                                            '& .MuiInputBase-input': {
                                                                padding: '0 8px',
                                                                fontSize: "inherit",
                                                                fontWeight: '600',
                                                                lineHeight: "inherit"
                                                            },
                                                            '& .MuiInputLabel-root': {
                                                                fontSize: "inherit",
                                                                fontWeight: '600',
                                                                top: '-4px',
                                                            },

                                                            '& .MuiInputLabel-shrink': {
                                                                transform: 'translate(14px, -3px) scale(0.58)',
                                                            },
                                                            '& .MuiOutlinedInput-notchedOutline legend': {
                                                                maxWidth: 0,
                                                            },
                                                            '& .Mui-focused .MuiOutlinedInput-notchedOutline legend': {
                                                                maxWidth: 2500,
                                                            }
                                                        }}
                                                    />
                                                )}
                                                fullWidth
                                                slotProps={{
                                                    popper: {
                                                        sx: {
                                                            '& .MuiAutocomplete-option': {
                                                                fontSize: 'inherit'
                                                            }
                                                        }
                                                    }
                                                }}
                                            />

                                        </Box>


                                        <Box sx={{ minWidth: 250, maxWidth: 300, flex: 1 }}>
                                            <Autocomplete
                                                options={optionsManager}
                                                getOptionLabel={(option) => option.label}
                                                value={filterManager}
                                                onChange={handleChangeManager}
                                                inputValue={inputValueManager}
                                                onInputChange={handleInputChangeManager}
                                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                                disabled={(user.data.managerId && !user.data.tradeAccountId) ? true : false}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Agente Productor"
                                                        variant="outlined"
                                                        sx={{
                                                            '& .MuiInputBase-root': {
                                                                height: 32,
                                                                minHeight: 32,
                                                                paddingRight: '8px',
                                                                fontSize: "inherit",
                                                                fontWeight: '600',
                                                                lineHeight: "inherit"
                                                            },
                                                            '& .MuiInputBase-input': {
                                                                padding: '0 8px',
                                                                fontSize: "inherit",
                                                                fontWeight: '600',
                                                                lineHeight: "inherit"
                                                            },
                                                            '& .MuiInputLabel-root': {
                                                                fontSize: "inherit",
                                                                fontWeight: '600',
                                                                top: '-4px',
                                                            },
                                                            '& .MuiInputLabel-shrink': {
                                                                transform: 'translate(14px, -3px) scale(0.58)',
                                                            },
                                                            '& .MuiOutlinedInput-notchedOutline legend': {
                                                                maxWidth: 0,
                                                            },
                                                            '& .Mui-focused .MuiOutlinedInput-notchedOutline legend': {
                                                                maxWidth: 2500,
                                                            }
                                                        }}
                                                    />
                                                )}
                                                fullWidth
                                            />


                                        </Box>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexDirection: { xs: "column", sm: "row" },
                                                gap: 1,
                                                flex: 1
                                            }}
                                        >
                                            <BlobProvider
                                                document={
                                                    <PerformancePdfExport
                                                        performanceReponse={performanceReponse}
                                                        homeTrade={homeTrade}
                                                        filterDate={filterDate}
                                                        filterDateHasta={filterDateHasta}
                                                        filterComitente={filterComitente}
                                                        filterManager={filterManager}
                                                        viewComitente={viewComitente}
                                                        viewManager={viewManager}
                                                    />
                                                }
                                            >
                                                {({ blob, loading }) => {

                                                    if (loading) {
                                                        return <PictureAsPdfIcon fontSize="large" color="disabled" />;
                                                    }

                                                    return (
                                                        <PictureAsPdfIcon
                                                            fontSize="large"
                                                            style={{ cursor: "pointer" }}
                                                            onClick={async () => {

                                                                const formData = new FormData();

                                                                formData.append(
                                                                    "file",
                                                                    blob,
                                                                    "performance.pdf"
                                                                );

                                                                const response = await informationService.pdfprotect(formData);

                                                                const protectedBlob = response.data;

                                                                const url = window.URL.createObjectURL(protectedBlob);

                                                                const a = document.createElement("a");

                                                                const moneda = homeTrade.toUpperCase();

                                                                const desde = filterDate
                                                                    ? filterDate.replaceAll("-", "")
                                                                    : "";

                                                                const hasta = filterDateHasta
                                                                    ? filterDateHasta.replaceAll("-", "")
                                                                    : "";

                                                                const nombre = [
                                                                    "Performance",
                                                                    moneda,
                                                                    desde,
                                                                    hasta
                                                                ].join("_");

                                                                a.href = url;
                                                                a.download = `${nombre}.pdf`;

                                                                document.body.appendChild(a);
                                                                a.click();
                                                                a.remove();

                                                                window.URL.revokeObjectURL(url);

                                                            }}
                                                        />
                                                    );

                                                }}
                                            </BlobProvider>

                                            <TableChartIcon
                                                fontSize="large"
                                                style={{ cursor: "pointer" }}
                                                onClick={exportToExcel}
                                            />


                                        </Box>


                                    </Box>

                                </Box>
                            </ThemeProvider>
                        </Box>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: { xs: 'column', md: 'row' }, // responsive: en mobile apila
                                justifyContent: 'space-between',             // separa gráfico y tabla
                                alignItems: 'flex-start',                    // alinea arriba
                                gap: 4,                                       // espacio entre ambos
                                width: '100%',
                                marginTop: '20px'
                            }}
                        >

                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: { xs: 'column', md: 'row' }, // Responsive
                                    gap: 2,
                                    flex: 1,
                                }}
                            >

                                {/*<Box sx={{ width: 250, height: 350, mx: 'auto' }}>
                                    <BarChart
                                        subtotalesCards={[
                                            { subtotal: 'ACCIONES', importe: '1500000' },
                                            { subtotal: 'BONOS', importe: '2500000' },
                                            { subtotal: 'FCI', importe: '900000' },
                                        ]}
                                    />
                                </Box>*/}
                            </Box>
                        </Box>
                    </Box>

                    <Box maxWidth={"800px"} marginLeft={"auto"} marginRight={"auto"} border={1} borderColor="rgb(0 0 0 / 13%)" borderRadius="4px" p={2} padding={1}>

                        {!loadSubtotalesCards && (
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <CircularProgress size={60} />
                            </div>
                        )}
                        {loadSubtotalesCards && (
                            <TableContainer component={Paper} sx={{
                                overflowX: 'auto',
                                overflowY: 'auto'
                            }}/*sx={{ maxHeight: '500px', overflowY: 'auto' }}*/>
                                <Table sx={{ minWidth: 650, height: '100%' }} aria-label="simple table">
                                    <TableHead>
                                        <TableRow sx={{ position: 'sticky', top: 0, zIndex: 5, backgroundColor: 'rgb(50 59 152)' }}>
                                            <TableCell style={{ color: 'white', textAlign: 'center' }}>Periodo</TableCell>
                                            <TableCell style={{ color: 'white', textAlign: 'center' }}>Inicio</TableCell>
                                            <TableCell style={{ color: 'white', textAlign: 'center' }}>Fin</TableCell>
                                            <TableCell style={{ color: 'white', textAlign: 'center' }}>Posición ({homeTrade.toUpperCase()})</TableCell>
                                            <TableCell style={{ color: 'white', textAlign: 'center' }}>Contribución ({homeTrade.toUpperCase()})</TableCell>
                                            <TableCell style={{ color: 'white', textAlign: 'center' }}>Cambio ({homeTrade.toUpperCase()})</TableCell>
                                            <TableCell style={{ color: 'white', textAlign: 'center' }}>Portfolio (%)</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            performanceReponse.map((item, index) => {
                                                return setViewPerformance(item, homeTrade);
                                            })
                                        }

                                    </TableBody>
                                </Table>
                            </TableContainer>
                        )}
                        <Box padding={1}>
                            <p style={{ fontSize: '10px', margin: '2px 0' }}>
                                Los saldos e información contenidos en el presente revisten carácter informativo y se encuentran sujetos a verificación.</p>
                            <p style={{ fontSize: '10px', margin: '2px 0' }}>
                                Salvo Error u Omisión (S.E.U.O.).</p>
                            <p style={{ fontSize: '10px', margin: '2px 0' }}>
                                La documentación respaldatoria de las operaciones se encuentra a disposición del cliente conforme la normativa vigente de la CNV (Título VII, Capítulo II T.O.).</p>
                        </Box>
                    </Box>

                </div >
            </ThemeProvider >


        </>
    )
}

export default Performance